import { GET_ACHIEVEMENTS, GET_ACHIEVEMENTS_SUCCESS } from '../constants';

export function getAchievements() {
  return { type: GET_ACHIEVEMENTS };
}

export function getAchievementsSuccess(payload) {
  return { type: GET_ACHIEVEMENTS_SUCCESS, payload };
}
